/**
 * AlmadarPostIkeaEffectSoftwareENAlmadarPostIkeaEffectSoftwareENPage
 *
 * Page component for AlmadarPostIkeaEffectSoftwareENAlmadarPostIkeaEffectSoftwareENPage
 * Path: /blog/ikea-effect-software
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostIkeaEffectSoftwareENPostPageView as __AlmadarPostIkeaEffectSoftwareENPostPageView } from '@/components/traits/AlmadarPostIkeaEffectSoftwareENPostPageView';
import { AlmadarPostIkeaEffectSoftwareENPostAnalyticsView as __AlmadarPostIkeaEffectSoftwareENPostAnalyticsView } from '@/components/traits/AlmadarPostIkeaEffectSoftwareENPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostIkeaEffectSoftwareENAlmadarPostIkeaEffectSoftwareENPageProps {
  // Add any page-level props here
}

export function AlmadarPostIkeaEffectSoftwareENAlmadarPostIkeaEffectSoftwareENPage(_props: AlmadarPostIkeaEffectSoftwareENAlmadarPostIkeaEffectSoftwareENPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostIkeaEffectSoftwareENPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostIkeaEffectSoftwareENPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostIkeaEffectSoftwareENAlmadarPostIkeaEffectSoftwareENPage;
